/**
 * @license lucide v0.356.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const MapPin = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" }],
    ["circle", { cx: "12", cy: "10", r: "3" }]
  ]
];

export { MapPin as default };
//# sourceMappingURL=map-pin.js.map
